import { Trans } from '@lingui/macro';
import React from 'react';
import { DynamicComponent } from '../../Base';

export default function PriceRange({ pricing, style, orientation }) {
  return (
    <DynamicComponent.Wrapper style={style} orientation={orientation}>
      <DynamicComponent.Label orientation={orientation}>
        <Trans>Price</Trans>
      </DynamicComponent.Label>
      <DynamicComponent.Value orientation={orientation}>
        {getPriceRange({ pricing })}
      </DynamicComponent.Value>
    </DynamicComponent.Wrapper>
  );
}

function getPriceRange({ pricing }) {
  if (!pricing) return 'Enquire about price';
  return pricing?.priceRange || 'Enquire about price';
}
